import addresses from './addresses.json'
import auth from './auth.json'
import billing from './billing.json'
import cancelSupplierSwitch from './cancelSupplierSwitch.json'
import common from './common.json'
import commonFormFields from './commonFormFields.json'
import consumption from './consumption.json'
import contracts from './contracts.json'
import errors from './errors.json'
import energyOverview from './energyOverview.json'
import feedbackWidget from './feedbackWidget.json'
import guaranteeOfOrigin from './guaranteeOfOrigin.json'
import home from './home.json'
import invoices from './invoices.json'
import marketPrices from './marketPrices.json'
import mysterySwitch from './mysterySwitch.json'
import move from './move.json'
import overview from './overview.json'
import producer from './producer.json'
import referral from './referral.json'
import sales from './sales.json'
import support from './support.json'
import user from './user.json'
import validation from './validation.json'
import tariffs from './tariffs.json'
import boltFixOptIn from './boltFixOptIn.json'

const resources = {
  addresses,
  auth,
  billing,
  boltFixOptIn,
  cancelSupplierSwitch,
  common,
  commonFormFields,
  consumption,
  contracts,
  errors,
  energyOverview,
  feedbackWidget,
  guaranteeOfOrigin,
  home,
  invoices,
  marketPrices,
  mysterySwitch,
  move,
  overview,
  producer,
  referral,
  sales,
  support,
  tariffs,
  user,
  validation
} as const

export default resources
